import type { ReactElement } from 'react';
import {
  RevenueMatrixTable,
  type MatrixVisibilityProps,
} from '@/components/dashboards/RevenueMatrixTable';
import type { RevenueMatrix } from '@/lib/revenue-matrix';

/**
 * ONE COMPANY'S REVENUE AS PRODUCTS × CYCLES — a thin wrapper over the shared
 * `RevenueMatrixTable` (layout, heat, crosshair, pinning, sorting, keyboard
 * grid, hiding and CSV all live there). This file only names the rows
 * ("Product"), the panel and the CSV file.
 */

export interface CompanyRevenueMatrixProps {
  matrix: RevenueMatrix;
  /** The ONE unit every figure in `matrix` is already in. */
  currencyCode: string;
  /** For the CSV's file name. */
  companyName: string;
  /** The panel's hidden years and products, shared by every expanded company. */
  visibility: MatrixVisibilityProps;
}

export function CompanyRevenueMatrix({
  matrix,
  currencyCode,
  companyName,
  visibility,
}: CompanyRevenueMatrixProps): ReactElement {
  return (
    <RevenueMatrixTable
      matrix={matrix}
      currencyCode={currencyCode}
      title="Revenue by product"
      subjectName={companyName}
      rowHeader="Product"
      csvFileName={`${companyName}-revenue-by-product.csv`}
      basisLabel="Paid, incl. tax"
      visibility={visibility}
    />
  );
}
